const handcuffs = [
  { value: 'NÃO HOUVE USO', label: 'NÃO HOUVE USO' },
  { value: 'RESISTÊNCIA', label: 'RESISTÊNCIA' },
  { value: 'RECEIO DE FUGA', label: 'RECEIO DE FUGA' },
  { value: 'RISCO À GUARNIÇÃO', label: 'RISCO À GUARNIÇÃO' },
  { value: 'RISCO À TERCEIROS', label: 'RISCO À TERCEIROS' },
];

export default handcuffs;
